export const getUserAgent = state => state.userAgent;
export const getIsMac = state => getUserAgent(state).isMac;
export const getIsIphone = state => getUserAgent(state).isiPhone;
